import { Link } from "react-router-dom";

function CrosswordHome() {
    return (
        <section className='content-wrapper'>
            <h1>십자말풀이</h1>
            <hr></hr>
            <article>
                <p>
                    <em>십자말풀이</em>는 흰색과 검은색으로 칠해진 격자판 위에서 진행하는 언어 퍼즐의 일종입니다.
                </p>
                <p>
                    흰색으로 칠해진 칸에는 한글 한 글자가 들어갑니다. 일직선으로 이어진 흰색 칸들에 들어간 글자들은 하나의 단어를 이룹니다. 검은색으로 칠해진 칸은 글자가 들어가지 않으며 이러한 단어를 분리합니다.
                </p>
                <p>
                    각 단어가 시작하는 칸에는 그 칸을 가리키는 숫자가 적혀 있습니다. 이 숫자는 단어를 채우기 위한 단서, <b>열쇠</b>에 사용됩니다. 각 열쇠는 그 단어의 방향과 함께 주어집니다. 따라서 채워진 글자들은 가로 방향의 열쇠와 세로 방향의 열쇠를 모두 만족해야 합니다.
                </p>
            </article>
            <div className="milestone-wrapper">
                <Link to='/crossword/general'><span className="milestone">정규 십자말풀이</span></Link>
                <Link to='/crossword/variant'><span className="milestone">변형 십자말풀이</span></Link>
                <Link to='/crossword/cryptic'><span className="milestone">난해한 십자말풀이</span></Link>
            </div>
        </section>
    );
}

export default CrosswordHome;